import util from '@bmp-vue/core/api/util'

const controller = 'SplitOperacoes'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist', 'delete']), {
  Historico: function (dto) {
    return util.Axios.GetAll(controller + '/Historico', dto)
  },
})
